const UriMaps = {
	
	name: 'UriMaps',
	model: {

		idProperty: 'key',
		displayProperty: 'value',

		properties: [
			{ name: 'key', },
			{ name: 'value', },
		],
		
	},

	repository: 'async',

};

export default UriMaps;
